import * as React from 'react';
import { useClickController } from '../../internal';
import { CustomTooltip } from '../CustomTooltip';
/**
 * Компонент подсказки в виде всплывающего текста
 *
 * @export
 * @param {IInformationTooltipDesktopProps} props
 * @returns
 */

export function InformationTooltipDesktop(props) {
  var header = props.header,
      content = props.content,
      arrow = props.arrow,
      placement = props.placement,
      theme = props.theme,
      portal = props.portal;

  var _useClickController = useClickController(props),
      childrenProps = _useClickController.childrenProps,
      childrenRef = _useClickController.childrenRef,
      open = _useClickController.open,
      handleClose = _useClickController.handleClose;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.cloneElement(props.children, childrenProps), /*#__PURE__*/React.createElement(CustomTooltip, {
    header: header,
    content: content,
    open: open,
    anchorRef: childrenRef,
    arrow: arrow,
    placement: placement,
    theme: theme,
    size: "M",
    portal: portal,
    flip: true,
    preventOverflow: true,
    closeButton: true,
    outside: true,
    onClose: handleClose
  }));
}